import {
  StyledHeaderReconcileReport,
  StyledColumnFilterPlaceHolder
} from '../styled';
import { OptionType } from '../types';
import { ColumnFilter } from './ColumnFilter';

export const ReconcileCustomHeader = ({
  options,
  onSelection
}: {
  options: OptionType[];
  onSelection: (selectedOptions: OptionType[]) => void;
}): React.JSX.Element => (
  <StyledHeaderReconcileReport>
    <StyledColumnFilterPlaceHolder>
      <ColumnFilter options={options} onSelection={onSelection} />
    </StyledColumnFilterPlaceHolder>
  </StyledHeaderReconcileReport>
);
